// iMoney Malaysia Referral System - Mock Data
// All amounts in RM (Malaysian Ringgit)

export const users = [
  {
    id: 'USR001',
    name: 'Ahmad Faizal bin Razak',
    email: 'ahmad.faizal@gmail.com',
    phone: '+60121234567',
    role: 'applicant',
    referralCode: 'REF-AF2024',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 120,
    totalReferrals: 3,
    joinDate: '2024-08-15',
  },
  {
    id: 'USR002',
    name: 'Siti Nurhaliza binti Ismail',
    email: 'siti.nurhaliza@yahoo.com',
    phone: '+60139876543',
    role: 'agent',
    referralCode: 'REF-SN2024',
    referralLevel: 'Gold',
    status: 'active',
    tokenBalance: 850,
    totalReferrals: 28,
    joinDate: '2023-11-02',
  },
  {
    id: 'USR003',
    name: 'Raj Kumar a/l Subramaniam',
    email: 'raj.kumar@hotmail.com',
    phone: '+60171122334',
    role: 'applicant',
    referralCode: 'REF-RK2024',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 45,
    totalReferrals: 1,
    joinDate: '2025-01-20',
  },
  {
    id: 'USR004',
    name: 'Tan Wei Ling',
    email: 'weiling.tan@gmail.com',
    phone: '+60161234890',
    role: 'agent',
    referralCode: 'REF-TW2024',
    referralLevel: 'Platinum',
    status: 'active',
    tokenBalance: 2340,
    totalReferrals: 67,
    joinDate: '2023-03-10',
  },
  {
    id: 'USR005',
    name: 'Mohd Hafiz bin Abdullah',
    email: 'hafiz.abdullah@imoney.my',
    phone: '+60181234567',
    role: 'admin',
    referralCode: null,
    referralLevel: null,
    status: 'active',
    tokenBalance: 0,
    totalReferrals: 0,
    joinDate: '2022-06-01',
  },
  {
    id: 'USR006',
    name: 'Nurul Izzah binti Hassan',
    email: 'nurul.izzah@protonmail.com',
    phone: '+60191234567',
    role: 'applicant',
    referralCode: 'REF-NI2024',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 80,
    totalReferrals: 2,
    joinDate: '2025-02-14',
  },
  {
    id: 'USR007',
    name: 'Lee Chong Wei',
    email: 'chongwei.lee@gmail.com',
    phone: '+60141234567',
    role: 'corporate_partner',
    referralCode: 'REF-LCW2024',
    referralLevel: 'Platinum',
    status: 'active',
    tokenBalance: 5600,
    totalReferrals: 142,
    joinDate: '2022-12-05',
  },
  {
    id: 'USR008',
    name: 'Fatimah binti Zainal',
    email: 'fatimah.zainal@outlook.com',
    phone: '+60111234567',
    role: 'applicant',
    referralCode: 'REF-FZ2025',
    referralLevel: 'Silver',
    status: 'pending',
    tokenBalance: 0,
    totalReferrals: 0,
    joinDate: '2025-03-28',
  },
  {
    id: 'USR009',
    name: 'Kavitha a/p Muthusamy',
    email: 'kavitha.m@gmail.com',
    phone: '+60151234567',
    role: 'agent',
    referralCode: 'REF-KM2024',
    referralLevel: 'Gold',
    status: 'active',
    tokenBalance: 1100,
    totalReferrals: 35,
    joinDate: '2023-07-19',
  },
  {
    id: 'USR010',
    name: 'Azman bin Osman',
    email: 'azman.osman@imoney.my',
    phone: '+60121239999',
    role: 'admin',
    referralCode: null,
    referralLevel: null,
    status: 'active',
    tokenBalance: 0,
    totalReferrals: 0,
    joinDate: '2022-01-15',
  },
  {
    id: 'USR011',
    name: 'Wong Mei Fen',
    email: 'meifen.wong@yahoo.com',
    phone: '+60131234567',
    role: 'applicant',
    referralCode: 'REF-WM2025',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 30,
    totalReferrals: 0,
    joinDate: '2025-03-01',
  },
  {
    id: 'USR012',
    name: 'Amir Hamzah bin Yusof',
    email: 'amir.hamzah@gmail.com',
    phone: '+60171239876',
    role: 'agent',
    referralCode: 'REF-AH2023',
    referralLevel: 'Platinum',
    status: 'active',
    tokenBalance: 3200,
    totalReferrals: 89,
    joinDate: '2023-02-01',
  },
  {
    id: 'USR013',
    name: 'Priya a/p Rajan',
    email: 'priya.rajan@hotmail.com',
    phone: '+60161239876',
    role: 'applicant',
    referralCode: 'REF-PR2025',
    referralLevel: 'Silver',
    status: 'inactive',
    tokenBalance: 15,
    totalReferrals: 0,
    joinDate: '2024-10-12',
  },
  {
    id: 'USR014',
    name: 'Lim Boon Keat',
    email: 'boonkeat.lim@gmail.com',
    phone: '+60181239876',
    role: 'corporate_partner',
    referralCode: 'REF-LBK2023',
    referralLevel: 'Platinum',
    status: 'active',
    tokenBalance: 4100,
    totalReferrals: 110,
    joinDate: '2023-01-20',
  },
  {
    id: 'USR015',
    name: 'Noraini binti Mohd Nor',
    email: 'noraini.mn@outlook.com',
    phone: '+60191239876',
    role: 'applicant',
    referralCode: 'REF-NM2024',
    referralLevel: 'Gold',
    status: 'active',
    tokenBalance: 450,
    totalReferrals: 12,
    joinDate: '2024-04-18',
  },
  {
    id: 'USR016',
    name: 'Saravanan a/l Krishnan',
    email: 'saravanan.k@gmail.com',
    phone: '+60141239876',
    role: 'agent',
    referralCode: 'REF-SK2024',
    referralLevel: 'Gold',
    status: 'active',
    tokenBalance: 920,
    totalReferrals: 31,
    joinDate: '2024-01-05',
  },
  {
    id: 'USR017',
    name: 'Zulaikha binti Karim',
    email: 'zulaikha.karim@yahoo.com',
    phone: '+60111239876',
    role: 'applicant',
    referralCode: 'REF-ZK2025',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 60,
    totalReferrals: 1,
    joinDate: '2025-02-28',
  },
  {
    id: 'USR018',
    name: 'Ong Jia Hui',
    email: 'jiahui.ong@gmail.com',
    phone: '+60151239876',
    role: 'corporate_partner',
    referralCode: 'REF-OJH2023',
    referralLevel: 'Platinum',
    status: 'active',
    tokenBalance: 6800,
    totalReferrals: 198,
    joinDate: '2022-09-15',
  },
  {
    id: 'USR019',
    name: 'Iskandar bin Shahril',
    email: 'iskandar.shah@hotmail.com',
    phone: '+60121237777',
    role: 'applicant',
    referralCode: 'REF-IS2025',
    referralLevel: 'Silver',
    status: 'pending',
    tokenBalance: 0,
    totalReferrals: 0,
    joinDate: '2025-03-25',
  },
  {
    id: 'USR020',
    name: 'Chandra a/l Segaran',
    email: 'chandra.segaran@gmail.com',
    phone: '+60131239999',
    role: 'agent',
    referralCode: 'REF-CS2024',
    referralLevel: 'Gold',
    status: 'active',
    tokenBalance: 780,
    totalReferrals: 24,
    joinDate: '2024-03-12',
  },
  // ─── 3-level downline seed for Ahmad Faizal (USR001) ─────────────
  // Used to demonstrate the simplified ReferralHistory page (eKYC + 3-level tree)
  // Level 1 — direct referrals of USR001
  {
    id: 'USR031',
    name: 'Hafiz bin Rahman',
    email: 'hafiz.rahman@gmail.com',
    phone: '+60123456789',
    icNumber: '900315012345',
    role: 'applicant',
    referralCode: 'REF-HR2025',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 45,
    totalReferrals: 2,
    joinDate: '2025-09-12',
    referredBy: 'USR001',
  },
  {
    id: 'USR032',
    name: 'Aisyah binti Mohd',
    email: 'aisyah.mohd@gmail.com',
    phone: '+60134567890',
    // icNumber missing → eKYC incomplete
    role: 'applicant',
    referralCode: 'REF-AM2025',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 15,
    totalReferrals: 0,
    joinDate: '2025-10-08',
    referredBy: 'USR001',
  },
  {
    id: 'USR033',
    name: 'Daniel Tan Jia Ming',
    email: 'daniel.tan@yahoo.com',
    phone: '+60145678901',
    icNumber: '930702045678',
    role: 'applicant',
    referralCode: 'REF-DT2025',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 30,
    totalReferrals: 1,
    joinDate: '2025-11-15',
    referredBy: 'USR001',
  },
  // Level 2 — downline of USR031 (Hafiz)
  {
    id: 'USR034',
    name: 'Farah binti Ismail',
    email: 'farah.ismail@gmail.com',
    phone: '+60156789012',
    icNumber: '950412067890',
    role: 'applicant',
    referralCode: 'REF-FI2025',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 20,
    totalReferrals: 1,
    joinDate: '2025-12-01',
    referredBy: 'USR031',
  },
  {
    id: 'USR035',
    name: 'Kavin a/l Suresh',
    email: 'kavin.suresh@gmail.com',
    // phone missing → eKYC incomplete
    role: 'applicant',
    referralCode: 'REF-KS2025',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 5,
    totalReferrals: 0,
    joinDate: '2026-01-20',
    referredBy: 'USR031',
  },
  // Level 2 — downline of USR033 (Daniel)
  {
    id: 'USR036',
    name: 'Lim Wei Jie',
    email: 'limweijie@gmail.com',
    phone: '+60178901234',
    icNumber: '960818089012',
    role: 'applicant',
    referralCode: 'REF-LWJ2026',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 10,
    totalReferrals: 0,
    joinDate: '2026-02-05',
    referredBy: 'USR033',
  },
  // Level 3 — downline of USR034 (Farah)
  {
    id: 'USR037',
    name: 'Zara binti Ahmad',
    email: 'zara.ahmad@gmail.com',
    phone: '+60189012345',
    icNumber: '980225011234',
    role: 'applicant',
    referralCode: 'REF-ZA2026',
    referralLevel: 'Silver',
    status: 'active',
    tokenBalance: 5,
    totalReferrals: 0,
    joinDate: '2026-03-12',
    referredBy: 'USR034',
  },
];

export const products = [
  {
    id: 'PROD001',
    name: 'Personal Financing-i',
    type: 'personal_financing',
    bank: 'Al Rajhi Bank',
    profitRate: 3.99,
    maxAmount: 200000,
    minSalary: 2000,
    features: [
      'Shariah-compliant (Tawarruq)',
      'Tenure up to 7 years',
      'No guarantor required',
      'Fast approval within 24 hours',
      'Flexible repayment options',
    ],
    icon: 'wallet',
  },
  {
    id: 'PROD002',
    name: 'Housing Loan-i',
    type: 'housing_loan',
    bank: 'Public Islamic Bank',
    profitRate: 3.65,
    maxAmount: 1000000,
    minSalary: 3500,
    features: [
      'Shariah-compliant (Musharakah Mutanaqisah)',
      'Tenure up to 35 years',
      'Margin of financing up to 90%',
      'Lock-in period of 3 years',
      'Free MRTA/MRTT coverage',
    ],
    icon: 'home',
  },
  {
    id: 'PROD003',
    name: 'Credit Card-i',
    type: 'credit_card',
    bank: 'CIMB Islamic',
    profitRate: 15.0,
    maxAmount: 50000,
    minSalary: 2500,
    features: [
      'Shariah-compliant (Ujrah)',
      'Cashback up to 8%',
      '0% Easy Payment Plan',
      'Complimentary airport lounge access',
      'Takaful coverage included',
    ],
    icon: 'credit-card',
  },
  {
    id: 'PROD004',
    name: 'Property Marketplace',
    type: 'property',
    bank: null,
    profitRate: null,
    maxAmount: null,
    minSalary: null,
    features: [
      'Verified property listings',
      'Sub-sale and new launch properties',
      'Instant loan eligibility check',
      'Virtual property tours',
      'Direct developer pricing',
    ],
    icon: 'building',
  },
  {
    id: 'PROD005',
    name: 'Auto Financing-i',
    type: 'auto_financing',
    bank: 'RHB Islamic Bank',
    profitRate: 2.78,
    maxAmount: 300000,
    minSalary: 2500,
    features: [
      'Shariah-compliant (Al-Ijarah Thumma Al-Bay)',
      'Tenure up to 9 years',
      'Margin of financing up to 90%',
      'New and used vehicles',
      'Quick disbursement to dealer',
    ],
    icon: 'car',
  },
];

export const cases = [
  {
    id: 'CASE001',
    applicantId: 'USR001',
    applicantName: 'Ahmad Faizal bin Razak',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 50000,
    status: 'Approved',
    referralCode: 'REF-SN2024',
    referralType: 'agent',
    referralOwnerId: 'USR002',
    createdAt: '2025-01-15T08:30:00Z',
    updatedAt: '2025-02-10T14:20:00Z',
    commissionAmount: 500,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE002',
    applicantId: 'USR003',
    applicantName: 'Raj Kumar a/l Subramaniam',
    productId: 'PROD002',
    productName: 'Housing Loan-i',
    bank: 'Public Islamic Bank',
    amount: 450000,
    status: 'Disbursed',
    referralCode: 'REF-TW2024',
    referralType: 'agent',
    referralOwnerId: 'USR004',
    createdAt: '2024-10-05T10:00:00Z',
    updatedAt: '2025-01-20T16:45:00Z',
    commissionAmount: 4500,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE003',
    applicantId: 'USR006',
    applicantName: 'Nurul Izzah binti Hassan',
    productId: 'PROD003',
    productName: 'Credit Card-i',
    bank: 'CIMB Islamic',
    amount: 15000,
    status: 'Approved',
    referralCode: 'REF-AF2024',
    referralType: 'referral',
    referralOwnerId: 'USR001',
    createdAt: '2025-02-20T09:15:00Z',
    updatedAt: '2025-03-05T11:30:00Z',
    commissionAmount: 150,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE004',
    applicantId: 'USR011',
    applicantName: 'Wong Mei Fen',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 30000,
    status: 'In Review',
    referralCode: 'REF-KM2024',
    referralType: 'agent',
    referralOwnerId: 'USR009',
    createdAt: '2025-03-15T14:00:00Z',
    updatedAt: '2025-03-18T09:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE005',
    applicantId: 'USR017',
    applicantName: 'Zulaikha binti Karim',
    productId: 'PROD005',
    productName: 'Auto Financing-i',
    bank: 'RHB Islamic Bank',
    amount: 85000,
    status: 'Pending Document',
    referralCode: 'REF-AH2023',
    referralType: 'agent',
    referralOwnerId: 'USR012',
    createdAt: '2025-03-20T11:30:00Z',
    updatedAt: '2025-03-22T16:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE006',
    applicantId: 'USR008',
    applicantName: 'Fatimah binti Zainal',
    productId: 'PROD002',
    productName: 'Housing Loan-i',
    bank: 'Public Islamic Bank',
    amount: 380000,
    status: 'Submitted',
    referralCode: null,
    referralType: 'self',
    referralOwnerId: null,
    createdAt: '2025-03-28T10:00:00Z',
    updatedAt: '2025-03-28T10:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'none',
  },
  {
    id: 'CASE007',
    applicantId: 'USR013',
    applicantName: 'Priya a/p Rajan',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 25000,
    status: 'Rejected',
    referralCode: 'REF-LCW2024',
    referralType: 'corporate',
    referralOwnerId: 'USR007',
    createdAt: '2024-11-10T08:00:00Z',
    updatedAt: '2024-12-01T15:30:00Z',
    commissionAmount: 0,
    commissionStatus: 'none',
  },
  {
    id: 'CASE008',
    applicantId: 'USR019',
    applicantName: 'Iskandar bin Shahril',
    productId: 'PROD003',
    productName: 'Credit Card-i',
    bank: 'CIMB Islamic',
    amount: 20000,
    status: 'Pending Bank Decision',
    referralCode: 'REF-CS2024',
    referralType: 'agent',
    referralOwnerId: 'USR020',
    createdAt: '2025-03-25T13:45:00Z',
    updatedAt: '2025-03-27T10:15:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE009',
    applicantId: 'USR001',
    applicantName: 'Ahmad Faizal bin Razak',
    productId: 'PROD005',
    productName: 'Auto Financing-i',
    bank: 'RHB Islamic Bank',
    amount: 120000,
    status: 'Disbursed',
    referralCode: null,
    referralType: 'self',
    referralOwnerId: null,
    createdAt: '2024-06-01T09:00:00Z',
    updatedAt: '2024-08-15T14:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'none',
  },
  {
    id: 'CASE010',
    applicantId: 'USR015',
    applicantName: 'Noraini binti Mohd Nor',
    productId: 'PROD002',
    productName: 'Housing Loan-i',
    bank: 'Public Islamic Bank',
    amount: 520000,
    status: 'Approved',
    referralCode: 'REF-LBK2023',
    referralType: 'corporate',
    referralOwnerId: 'USR014',
    createdAt: '2024-09-01T10:30:00Z',
    updatedAt: '2025-01-10T12:00:00Z',
    commissionAmount: 5200,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE011',
    applicantId: 'USR006',
    applicantName: 'Nurul Izzah binti Hassan',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 40000,
    status: 'Closed',
    referralCode: 'REF-SN2024',
    referralType: 'agent',
    referralOwnerId: 'USR002',
    createdAt: '2024-03-10T08:00:00Z',
    updatedAt: '2024-09-10T16:00:00Z',
    commissionAmount: 400,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE012',
    applicantId: 'USR003',
    applicantName: 'Raj Kumar a/l Subramaniam',
    productId: 'PROD003',
    productName: 'Credit Card-i',
    bank: 'CIMB Islamic',
    amount: 25000,
    status: 'Approved',
    referralCode: 'REF-TW2024',
    referralType: 'agent',
    referralOwnerId: 'USR004',
    createdAt: '2025-01-10T11:00:00Z',
    updatedAt: '2025-02-05T09:30:00Z',
    commissionAmount: 250,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE013',
    applicantId: 'USR011',
    applicantName: 'Wong Mei Fen',
    productId: 'PROD005',
    productName: 'Auto Financing-i',
    bank: 'RHB Islamic Bank',
    amount: 95000,
    status: 'Submitted',
    referralCode: 'REF-NM2024',
    referralType: 'referral',
    referralOwnerId: 'USR015',
    createdAt: '2025-03-30T09:45:00Z',
    updatedAt: '2025-03-30T09:45:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE014',
    applicantId: 'USR017',
    applicantName: 'Zulaikha binti Karim',
    productId: 'PROD002',
    productName: 'Housing Loan-i',
    bank: 'Public Islamic Bank',
    amount: 350000,
    status: 'Pending Document',
    referralCode: 'REF-OJH2023',
    referralType: 'corporate',
    referralOwnerId: 'USR018',
    createdAt: '2025-03-10T14:20:00Z',
    updatedAt: '2025-03-20T10:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE015',
    applicantId: 'USR008',
    applicantName: 'Fatimah binti Zainal',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 60000,
    status: 'In Review',
    referralCode: 'REF-SK2024',
    referralType: 'agent',
    referralOwnerId: 'USR016',
    createdAt: '2025-03-28T15:30:00Z',
    updatedAt: '2025-03-30T08:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE016',
    applicantId: 'USR019',
    applicantName: 'Iskandar bin Shahril',
    productId: 'PROD005',
    productName: 'Auto Financing-i',
    bank: 'RHB Islamic Bank',
    amount: 145000,
    status: 'Submitted',
    referralCode: 'REF-AH2023',
    referralType: 'agent',
    referralOwnerId: 'USR012',
    createdAt: '2025-03-29T10:00:00Z',
    updatedAt: '2025-03-29T10:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE017',
    applicantId: 'USR015',
    applicantName: 'Noraini binti Mohd Nor',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 80000,
    status: 'Disbursed',
    referralCode: 'REF-SN2024',
    referralType: 'agent',
    referralOwnerId: 'USR002',
    createdAt: '2024-07-15T08:30:00Z',
    updatedAt: '2024-10-01T16:00:00Z',
    commissionAmount: 800,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE018',
    applicantId: 'USR001',
    applicantName: 'Ahmad Faizal bin Razak',
    productId: 'PROD003',
    productName: 'Credit Card-i',
    bank: 'CIMB Islamic',
    amount: 30000,
    status: 'Approved',
    referralCode: null,
    referralType: 'self',
    referralOwnerId: null,
    createdAt: '2025-02-01T12:00:00Z',
    updatedAt: '2025-02-28T10:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'none',
  },
  {
    id: 'CASE019',
    applicantId: 'USR013',
    applicantName: 'Priya a/p Rajan',
    productId: 'PROD002',
    productName: 'Housing Loan-i',
    bank: 'Public Islamic Bank',
    amount: 280000,
    status: 'Rejected',
    referralCode: 'REF-KM2024',
    referralType: 'agent',
    referralOwnerId: 'USR009',
    createdAt: '2024-08-20T09:00:00Z',
    updatedAt: '2024-10-15T14:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'none',
  },
  {
    id: 'CASE020',
    applicantId: 'USR006',
    applicantName: 'Nurul Izzah binti Hassan',
    productId: 'PROD005',
    productName: 'Auto Financing-i',
    bank: 'RHB Islamic Bank',
    amount: 68000,
    status: 'Pending Bank Decision',
    referralCode: 'REF-TW2024',
    referralType: 'agent',
    referralOwnerId: 'USR004',
    createdAt: '2025-03-12T11:00:00Z',
    updatedAt: '2025-03-25T15:30:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE021',
    applicantId: 'USR011',
    applicantName: 'Wong Mei Fen',
    productId: 'PROD002',
    productName: 'Housing Loan-i',
    bank: 'Public Islamic Bank',
    amount: 420000,
    status: 'Submitted',
    referralCode: 'REF-LBK2023',
    referralType: 'corporate',
    referralOwnerId: 'USR014',
    createdAt: '2025-03-31T08:30:00Z',
    updatedAt: '2025-03-31T08:30:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE022',
    applicantId: 'USR017',
    applicantName: 'Zulaikha binti Karim',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 35000,
    status: 'Approved',
    referralCode: 'REF-CS2024',
    referralType: 'agent',
    referralOwnerId: 'USR020',
    createdAt: '2025-01-20T10:15:00Z',
    updatedAt: '2025-02-15T09:00:00Z',
    commissionAmount: 350,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE023',
    applicantId: 'USR003',
    applicantName: 'Raj Kumar a/l Subramaniam',
    productId: 'PROD005',
    productName: 'Auto Financing-i',
    bank: 'RHB Islamic Bank',
    amount: 110000,
    status: 'Disbursed',
    referralCode: 'REF-OJH2023',
    referralType: 'corporate',
    referralOwnerId: 'USR018',
    createdAt: '2024-05-15T14:00:00Z',
    updatedAt: '2024-08-01T10:30:00Z',
    commissionAmount: 1100,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE024',
    applicantId: 'USR019',
    applicantName: 'Iskandar bin Shahril',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 45000,
    status: 'In Review',
    referralCode: 'REF-SN2024',
    referralType: 'agent',
    referralOwnerId: 'USR002',
    createdAt: '2025-03-26T09:00:00Z',
    updatedAt: '2025-03-28T14:30:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE025',
    applicantId: 'USR008',
    applicantName: 'Fatimah binti Zainal',
    productId: 'PROD003',
    productName: 'Credit Card-i',
    bank: 'CIMB Islamic',
    amount: 10000,
    status: 'Approved',
    referralCode: 'REF-LCW2024',
    referralType: 'corporate',
    referralOwnerId: 'USR007',
    createdAt: '2025-02-10T11:45:00Z',
    updatedAt: '2025-03-01T09:30:00Z',
    commissionAmount: 100,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE026',
    applicantId: 'USR015',
    applicantName: 'Noraini binti Mohd Nor',
    productId: 'PROD005',
    productName: 'Auto Financing-i',
    bank: 'RHB Islamic Bank',
    amount: 75000,
    status: 'Pending Document',
    referralCode: 'REF-AH2023',
    referralType: 'agent',
    referralOwnerId: 'USR012',
    createdAt: '2025-03-18T10:00:00Z',
    updatedAt: '2025-03-25T11:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE027',
    applicantId: 'USR001',
    applicantName: 'Ahmad Faizal bin Razak',
    productId: 'PROD002',
    productName: 'Housing Loan-i',
    bank: 'Public Islamic Bank',
    amount: 550000,
    status: 'Pending Bank Decision',
    referralCode: 'REF-TW2024',
    referralType: 'agent',
    referralOwnerId: 'USR004',
    createdAt: '2025-03-05T08:00:00Z',
    updatedAt: '2025-03-28T16:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE028',
    applicantId: 'USR006',
    applicantName: 'Nurul Izzah binti Hassan',
    productId: 'PROD002',
    productName: 'Housing Loan-i',
    bank: 'Public Islamic Bank',
    amount: 320000,
    status: 'Disbursed',
    referralCode: 'REF-LBK2023',
    referralType: 'corporate',
    referralOwnerId: 'USR014',
    createdAt: '2024-04-20T09:30:00Z',
    updatedAt: '2024-09-15T14:00:00Z',
    commissionAmount: 3200,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE029',
    applicantId: 'USR011',
    applicantName: 'Wong Mei Fen',
    productId: 'PROD003',
    productName: 'Credit Card-i',
    bank: 'CIMB Islamic',
    amount: 18000,
    status: 'Submitted',
    referralCode: 'REF-SK2024',
    referralType: 'agent',
    referralOwnerId: 'USR016',
    createdAt: '2025-03-31T14:00:00Z',
    updatedAt: '2025-03-31T14:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE030',
    applicantId: 'USR013',
    applicantName: 'Priya a/p Rajan',
    productId: 'PROD005',
    productName: 'Auto Financing-i',
    bank: 'RHB Islamic Bank',
    amount: 55000,
    status: 'Closed',
    referralCode: 'REF-OJH2023',
    referralType: 'corporate',
    referralOwnerId: 'USR018',
    createdAt: '2024-01-10T10:00:00Z',
    updatedAt: '2024-07-10T16:30:00Z',
    commissionAmount: 550,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE031',
    applicantId: 'USR017',
    applicantName: 'Zulaikha binti Karim',
    productId: 'PROD003',
    productName: 'Credit Card-i',
    bank: 'CIMB Islamic',
    amount: 12000,
    status: 'Approved',
    referralCode: 'REF-SN2024',
    referralType: 'agent',
    referralOwnerId: 'USR002',
    createdAt: '2025-02-14T08:30:00Z',
    updatedAt: '2025-03-10T11:00:00Z',
    commissionAmount: 120,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE032',
    applicantId: 'USR019',
    applicantName: 'Iskandar bin Shahril',
    productId: 'PROD002',
    productName: 'Housing Loan-i',
    bank: 'Public Islamic Bank',
    amount: 480000,
    status: 'In Review',
    referralCode: 'REF-KM2024',
    referralType: 'agent',
    referralOwnerId: 'USR009',
    createdAt: '2025-03-22T13:00:00Z',
    updatedAt: '2025-03-28T09:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE033',
    applicantId: 'USR003',
    applicantName: 'Raj Kumar a/l Subramaniam',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 70000,
    status: 'Disbursed',
    referralCode: 'REF-LCW2024',
    referralType: 'corporate',
    referralOwnerId: 'USR007',
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-11-15T15:00:00Z',
    commissionAmount: 700,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE034',
    applicantId: 'USR015',
    applicantName: 'Noraini binti Mohd Nor',
    productId: 'PROD003',
    productName: 'Credit Card-i',
    bank: 'CIMB Islamic',
    amount: 22000,
    status: 'Approved',
    referralCode: 'REF-TW2024',
    referralType: 'agent',
    referralOwnerId: 'USR004',
    createdAt: '2025-01-05T10:30:00Z',
    updatedAt: '2025-02-01T09:00:00Z',
    commissionAmount: 220,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE035',
    applicantId: 'USR008',
    applicantName: 'Fatimah binti Zainal',
    productId: 'PROD005',
    productName: 'Auto Financing-i',
    bank: 'RHB Islamic Bank',
    amount: 98000,
    status: 'Pending Bank Decision',
    referralCode: 'REF-AH2023',
    referralType: 'agent',
    referralOwnerId: 'USR012',
    createdAt: '2025-03-15T11:00:00Z',
    updatedAt: '2025-03-29T10:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE036',
    applicantId: 'USR006',
    applicantName: 'Nurul Izzah binti Hassan',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 55000,
    status: 'Submitted',
    referralCode: 'REF-CS2024',
    referralType: 'agent',
    referralOwnerId: 'USR020',
    createdAt: '2025-04-01T08:00:00Z',
    updatedAt: '2025-04-01T08:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE037',
    applicantId: 'USR011',
    applicantName: 'Wong Mei Fen',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 42000,
    status: 'Rejected',
    referralCode: 'REF-LBK2023',
    referralType: 'corporate',
    referralOwnerId: 'USR014',
    createdAt: '2024-12-01T10:00:00Z',
    updatedAt: '2025-01-15T14:30:00Z',
    commissionAmount: 0,
    commissionStatus: 'none',
  },
  {
    id: 'CASE038',
    applicantId: 'USR001',
    applicantName: 'Ahmad Faizal bin Razak',
    productId: 'PROD004',
    productName: 'Property Marketplace',
    bank: null,
    amount: 750000,
    status: 'In Review',
    referralCode: null,
    referralType: 'self',
    referralOwnerId: null,
    createdAt: '2025-03-20T09:00:00Z',
    updatedAt: '2025-03-28T11:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'none',
  },
  {
    id: 'CASE039',
    applicantId: 'USR017',
    applicantName: 'Zulaikha binti Karim',
    productId: 'PROD004',
    productName: 'Property Marketplace',
    bank: null,
    amount: 480000,
    status: 'Submitted',
    referralCode: 'REF-OJH2023',
    referralType: 'corporate',
    referralOwnerId: 'USR018',
    createdAt: '2025-03-30T14:30:00Z',
    updatedAt: '2025-03-30T14:30:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE040',
    applicantId: 'USR013',
    applicantName: 'Priya a/p Rajan',
    productId: 'PROD003',
    productName: 'Credit Card-i',
    bank: 'CIMB Islamic',
    amount: 15000,
    status: 'Closed',
    referralCode: 'REF-SN2024',
    referralType: 'agent',
    referralOwnerId: 'USR002',
    createdAt: '2024-02-10T10:00:00Z',
    updatedAt: '2024-08-10T15:00:00Z',
    commissionAmount: 150,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE041',
    applicantId: 'USR003',
    applicantName: 'Raj Kumar a/l Subramaniam',
    productId: 'PROD004',
    productName: 'Property Marketplace',
    bank: null,
    amount: 620000,
    status: 'Pending Document',
    referralCode: 'REF-TW2024',
    referralType: 'agent',
    referralOwnerId: 'USR004',
    createdAt: '2025-03-08T11:30:00Z',
    updatedAt: '2025-03-22T09:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE042',
    applicantId: 'USR019',
    applicantName: 'Iskandar bin Shahril',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 90000,
    status: 'Submitted',
    referralCode: 'REF-LCW2024',
    referralType: 'corporate',
    referralOwnerId: 'USR007',
    createdAt: '2025-04-01T14:00:00Z',
    updatedAt: '2025-04-01T14:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE043',
    applicantId: 'USR015',
    applicantName: 'Noraini binti Mohd Nor',
    productId: 'PROD004',
    productName: 'Property Marketplace',
    bank: null,
    amount: 890000,
    status: 'Approved',
    referralCode: 'REF-SK2024',
    referralType: 'agent',
    referralOwnerId: 'USR016',
    createdAt: '2024-11-01T09:00:00Z',
    updatedAt: '2025-02-01T14:00:00Z',
    commissionAmount: 8900,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE044',
    applicantId: 'USR006',
    applicantName: 'Nurul Izzah binti Hassan',
    productId: 'PROD004',
    productName: 'Property Marketplace',
    bank: null,
    amount: 530000,
    status: 'Pending Bank Decision',
    referralCode: 'REF-AH2023',
    referralType: 'agent',
    referralOwnerId: 'USR012',
    createdAt: '2025-03-01T10:00:00Z',
    updatedAt: '2025-03-25T16:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE045',
    applicantId: 'USR008',
    applicantName: 'Fatimah binti Zainal',
    productId: 'PROD004',
    productName: 'Property Marketplace',
    bank: null,
    amount: 380000,
    status: 'In Review',
    referralCode: 'REF-OJH2023',
    referralType: 'corporate',
    referralOwnerId: 'USR018',
    createdAt: '2025-03-28T16:00:00Z',
    updatedAt: '2025-03-31T10:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE046',
    applicantId: 'USR011',
    applicantName: 'Wong Mei Fen',
    productId: 'PROD004',
    productName: 'Property Marketplace',
    bank: null,
    amount: 720000,
    status: 'Submitted',
    referralCode: 'REF-KM2024',
    referralType: 'agent',
    referralOwnerId: 'USR009',
    createdAt: '2025-04-02T09:00:00Z',
    updatedAt: '2025-04-02T09:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE047',
    applicantId: 'USR001',
    applicantName: 'Ahmad Faizal bin Razak',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 100000,
    status: 'Closed',
    referralCode: 'REF-TW2024',
    referralType: 'agent',
    referralOwnerId: 'USR004',
    createdAt: '2023-12-01T08:00:00Z',
    updatedAt: '2024-06-01T16:00:00Z',
    commissionAmount: 1000,
    commissionStatus: 'paid',
  },
  {
    id: 'CASE048',
    applicantId: 'USR017',
    applicantName: 'Zulaikha binti Karim',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 28000,
    status: 'Approved',
    referralCode: 'REF-LBK2023',
    referralType: 'corporate',
    referralOwnerId: 'USR014',
    createdAt: '2025-02-20T10:00:00Z',
    updatedAt: '2025-03-15T14:00:00Z',
    commissionAmount: 280,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE049',
    applicantId: 'USR013',
    applicantName: 'Priya a/p Rajan',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 38000,
    status: 'Pending Document',
    referralCode: 'REF-CS2024',
    referralType: 'agent',
    referralOwnerId: 'USR020',
    createdAt: '2025-03-25T15:00:00Z',
    updatedAt: '2025-03-30T10:00:00Z',
    commissionAmount: 0,
    commissionStatus: 'pending',
  },
  {
    id: 'CASE050',
    applicantId: 'USR003',
    applicantName: 'Raj Kumar a/l Subramaniam',
    productId: 'PROD001',
    productName: 'Personal Financing-i',
    bank: 'Al Rajhi Bank',
    amount: 55000,
    status: 'Disbursed',
    referralCode: 'REF-SN2024',
    referralType: 'agent',
    referralOwnerId: 'USR002',
    createdAt: '2024-09-10T09:00:00Z',
    updatedAt: '2025-01-05T14:30:00Z',
    commissionAmount: 550,
    commissionStatus: 'paid',
  },
];

export const partners = [
  {
    id: 'PTR001',
    name: 'Hartanah Sdn Bhd',
    type: 'corporate',
    status: 'active',
    referralCode: 'REF-LCW2024',
    totalCases: 142,
    totalCommission: 85200,
    commissionScheme: 'SCHEME001',
    downlineCount: 15,
    joinDate: '2022-12-05',
    products: ['PROD001', 'PROD002', 'PROD004'],
  },
  {
    id: 'PTR002',
    name: 'FinServ Capital Sdn Bhd',
    type: 'corporate',
    status: 'active',
    referralCode: 'REF-LBK2023',
    totalCases: 110,
    totalCommission: 66000,
    commissionScheme: 'SCHEME002',
    downlineCount: 12,
    joinDate: '2023-01-20',
    products: ['PROD001', 'PROD002', 'PROD003', 'PROD005'],
  },
  {
    id: 'PTR003',
    name: 'Ong Wealth Advisory',
    type: 'corporate',
    status: 'active',
    referralCode: 'REF-OJH2023',
    totalCases: 198,
    totalCommission: 118800,
    commissionScheme: 'SCHEME001',
    downlineCount: 22,
    joinDate: '2022-09-15',
    products: ['PROD001', 'PROD002', 'PROD003', 'PROD004', 'PROD005'],
  },
  {
    id: 'PTR004',
    name: 'Siti Nurhaliza binti Ismail',
    type: 'individual',
    status: 'active',
    referralCode: 'REF-SN2024',
    totalCases: 28,
    totalCommission: 16800,
    commissionScheme: 'SCHEME003',
    downlineCount: 3,
    joinDate: '2023-11-02',
    products: ['PROD001', 'PROD003'],
  },
  {
    id: 'PTR005',
    name: 'Tan Wei Ling',
    type: 'individual',
    status: 'active',
    referralCode: 'REF-TW2024',
    totalCases: 67,
    totalCommission: 40200,
    commissionScheme: 'SCHEME004',
    downlineCount: 8,
    joinDate: '2023-03-10',
    products: ['PROD001', 'PROD002', 'PROD003', 'PROD005'],
  },
  {
    id: 'PTR006',
    name: 'Amir Hamzah bin Yusof',
    type: 'individual',
    status: 'active',
    referralCode: 'REF-AH2023',
    totalCases: 89,
    totalCommission: 53400,
    commissionScheme: 'SCHEME004',
    downlineCount: 10,
    joinDate: '2023-02-01',
    products: ['PROD001', 'PROD002', 'PROD005'],
  },
  {
    id: 'PTR007',
    name: 'Kavitha a/p Muthusamy',
    type: 'individual',
    status: 'active',
    referralCode: 'REF-KM2024',
    totalCases: 35,
    totalCommission: 21000,
    commissionScheme: 'SCHEME003',
    downlineCount: 4,
    joinDate: '2023-07-19',
    products: ['PROD001', 'PROD002'],
  },
  {
    id: 'PTR008',
    name: 'ProWealth Solutions Sdn Bhd',
    type: 'corporate',
    status: 'inactive',
    referralCode: 'REF-PWS2023',
    totalCases: 45,
    totalCommission: 27000,
    commissionScheme: 'SCHEME002',
    downlineCount: 6,
    joinDate: '2023-04-15',
    products: ['PROD001', 'PROD003'],
  },
  {
    id: 'PTR009',
    name: 'Saravanan a/l Krishnan',
    type: 'individual',
    status: 'active',
    referralCode: 'REF-SK2024',
    totalCases: 31,
    totalCommission: 18600,
    commissionScheme: 'SCHEME003',
    downlineCount: 2,
    joinDate: '2024-01-05',
    products: ['PROD001', 'PROD004', 'PROD005'],
  },
  {
    id: 'PTR010',
    name: 'Chandra a/l Segaran',
    type: 'individual',
    status: 'active',
    referralCode: 'REF-CS2024',
    totalCases: 24,
    totalCommission: 14400,
    commissionScheme: 'SCHEME005',
    downlineCount: 1,
    joinDate: '2024-03-12',
    products: ['PROD001', 'PROD003', 'PROD005'],
  },
];

export const commissionSchemes = [
  {
    id: 'SCHEME001',
    name: 'Corporate Premium',
    productType: 'all',
    tiers: [
      { min: 0, max: 50000, rate: 1.5, type: 'percentage' },
      { min: 50001, max: 200000, rate: 1.2, type: 'percentage' },
      { min: 200001, max: 500000, rate: 1.0, type: 'percentage' },
      { min: 500001, max: null, rate: 0.8, type: 'percentage' },
    ],
  },
  {
    id: 'SCHEME002',
    name: 'Corporate Standard',
    productType: 'all',
    tiers: [
      { min: 0, max: 50000, rate: 1.0, type: 'percentage' },
      { min: 50001, max: 200000, rate: 0.8, type: 'percentage' },
      { min: 200001, max: null, rate: 0.6, type: 'percentage' },
    ],
  },
  {
    id: 'SCHEME003',
    name: 'Agent Basic',
    productType: 'personal_financing',
    tiers: [
      { min: 0, max: 30000, rate: 300, type: 'flat' },
      { min: 30001, max: 100000, rate: 500, type: 'flat' },
      { min: 100001, max: null, rate: 1.0, type: 'percentage' },
    ],
  },
  {
    id: 'SCHEME004',
    name: 'Agent Premium',
    productType: 'all',
    tiers: [
      { min: 0, max: 50000, rate: 1.2, type: 'percentage' },
      { min: 50001, max: 200000, rate: 1.0, type: 'percentage' },
      { min: 200001, max: null, rate: 0.8, type: 'percentage' },
    ],
  },
  {
    id: 'SCHEME005',
    name: 'Agent Starter',
    productType: 'personal_financing',
    tiers: [
      { min: 0, max: 50000, rate: 200, type: 'flat' },
      { min: 50001, max: null, rate: 0.5, type: 'percentage' },
    ],
  },
];

export const rewardConfig = {
  personal_financing: {
    selfApplication: { submitted: 10, approved: 30, disbursed: 50 },
    referralApplication: { submitted: 15, approved: 50, disbursed: 80 },
  },
  housing_loan: {
    selfApplication: { submitted: 15, approved: 50, disbursed: 100 },
    referralApplication: { submitted: 20, approved: 80, disbursed: 150 },
  },
  credit_card: {
    selfApplication: { submitted: 5, approved: 20, disbursed: 30 },
    referralApplication: { submitted: 10, approved: 30, disbursed: 50 },
  },
  property: {
    selfApplication: { submitted: 10, approved: 40, disbursed: 80 },
    referralApplication: { submitted: 15, approved: 60, disbursed: 120 },
  },
  auto_financing: {
    selfApplication: { submitted: 10, approved: 30, disbursed: 60 },
    referralApplication: { submitted: 15, approved: 50, disbursed: 90 },
  },
};

export const notifications = [
  {
    id: 'NOTIF001',
    type: 'case_update',
    title: 'Application Approved',
    message: 'Your Personal Financing-i application (CASE001) has been approved by Al Rajhi Bank.',
    recipientId: 'USR001',
    read: true,
    createdAt: '2025-02-10T14:20:00Z',
  },
  {
    id: 'NOTIF002',
    type: 'commission',
    title: 'Commission Earned',
    message: 'You have earned RM 500 commission from case CASE001. The amount will be credited to your account.',
    recipientId: 'USR002',
    read: true,
    createdAt: '2025-02-10T14:25:00Z',
  },
  {
    id: 'NOTIF003',
    type: 'referral',
    title: 'New Referral Sign-up',
    message: 'Nurul Izzah binti Hassan has signed up using your referral code REF-AF2024.',
    recipientId: 'USR001',
    read: true,
    createdAt: '2025-02-20T09:20:00Z',
  },
  {
    id: 'NOTIF004',
    type: 'document_required',
    title: 'Document Required',
    message: 'Please upload your latest 3-month payslip for your Auto Financing-i application (CASE005).',
    recipientId: 'USR017',
    read: false,
    createdAt: '2025-03-22T16:00:00Z',
  },
  {
    id: 'NOTIF005',
    type: 'case_update',
    title: 'Application Under Review',
    message: 'Your Personal Financing-i application (CASE004) is now under review by Al Rajhi Bank.',
    recipientId: 'USR011',
    read: false,
    createdAt: '2025-03-18T09:00:00Z',
  },
  {
    id: 'NOTIF006',
    type: 'reward',
    title: 'Tokens Earned',
    message: 'You have earned 50 iMoney tokens for your successful Personal Financing-i disbursement.',
    recipientId: 'USR001',
    read: true,
    createdAt: '2024-08-15T14:30:00Z',
  },
  {
    id: 'NOTIF007',
    type: 'promotion',
    title: 'Level Upgrade',
    message: 'Congratulations! You have been upgraded to Gold level. Enjoy enhanced commission rates.',
    recipientId: 'USR015',
    read: true,
    createdAt: '2024-12-01T10:00:00Z',
  },
  {
    id: 'NOTIF008',
    type: 'campaign',
    title: 'New Campaign Available',
    message: 'Raya 2025 Special: Earn double tokens on all Personal Financing-i applications this month!',
    recipientId: 'USR002',
    read: false,
    createdAt: '2025-03-15T08:00:00Z',
  },
  {
    id: 'NOTIF009',
    type: 'case_update',
    title: 'Application Rejected',
    message: 'Your Personal Financing-i application (CASE007) has been rejected. Please contact support for details.',
    recipientId: 'USR013',
    read: true,
    createdAt: '2024-12-01T15:30:00Z',
  },
  {
    id: 'NOTIF010',
    type: 'system',
    title: 'System Maintenance',
    message: 'Scheduled system maintenance on 5 April 2025, 2:00 AM - 6:00 AM MYT. Services may be unavailable.',
    recipientId: 'USR005',
    read: false,
    createdAt: '2025-04-01T10:00:00Z',
  },
  {
    id: 'NOTIF011',
    type: 'commission',
    title: 'Commission Paid',
    message: 'Your commission of RM 4,500 for Housing Loan-i (CASE002) has been transferred to your bank account.',
    recipientId: 'USR004',
    read: true,
    createdAt: '2025-01-25T09:00:00Z',
  },
  {
    id: 'NOTIF012',
    type: 'document_required',
    title: 'Additional Document Needed',
    message: 'Bank requires your EPF statement for Housing Loan-i application (CASE014). Please upload within 7 days.',
    recipientId: 'USR017',
    read: false,
    createdAt: '2025-03-20T10:00:00Z',
  },
  {
    id: 'NOTIF013',
    type: 'referral',
    title: 'Referral Application Submitted',
    message: 'Wong Mei Fen has submitted an Auto Financing-i application through your referral link.',
    recipientId: 'USR015',
    read: false,
    createdAt: '2025-03-30T09:50:00Z',
  },
  {
    id: 'NOTIF014',
    type: 'case_update',
    title: 'Loan Disbursed',
    message: 'Your Auto Financing-i loan (CASE023) of RM 110,000 has been disbursed to the dealer.',
    recipientId: 'USR003',
    read: true,
    createdAt: '2024-08-01T10:30:00Z',
  },
  {
    id: 'NOTIF015',
    type: 'reward',
    title: 'Bonus Tokens',
    message: 'You earned 100 bonus tokens from the Raya Referral Campaign. Total balance: 850 tokens.',
    recipientId: 'USR002',
    read: false,
    createdAt: '2025-04-01T08:00:00Z',
  },
];

export const campaigns = [
  {
    id: 'CAMP001',
    name: 'Raya 2025 Special',
    code: 'RAYA2025',
    type: 'both',
    startDate: '2025-03-15',
    endDate: '2025-04-30',
    status: 'active',
    totalLeads: 320,
    conversions: 85,
  },
  {
    id: 'CAMP002',
    name: 'First Home Buyer Promo',
    code: 'FIRSTHOME25',
    type: 'link',
    startDate: '2025-01-01',
    endDate: '2025-06-30',
    status: 'active',
    totalLeads: 540,
    conversions: 120,
  },
  {
    id: 'CAMP003',
    name: 'Credit Card Cashback Blast',
    code: 'CCBLAST25',
    type: 'qr',
    startDate: '2025-02-01',
    endDate: '2025-03-31',
    status: 'ended',
    totalLeads: 210,
    conversions: 68,
  },
  {
    id: 'CAMP004',
    name: 'Agent Recruitment Drive Q2',
    code: 'AGENTQ2',
    type: 'both',
    startDate: '2025-04-01',
    endDate: '2025-06-30',
    status: 'active',
    totalLeads: 45,
    conversions: 8,
  },
  {
    id: 'CAMP005',
    name: 'Auto Financing Year-End',
    code: 'AUTOYE24',
    type: 'link',
    startDate: '2024-10-01',
    endDate: '2024-12-31',
    status: 'ended',
    totalLeads: 680,
    conversions: 195,
  },
];

export const marketingMaterials = [
  {
    id: 'MAT001',
    name: 'Personal Financing-i Product Brochure',
    type: 'brochure',
    product: 'PROD001',
    fileSize: '2.4 MB',
    thumbnail: '/assets/materials/pf-brochure-thumb.png',
    downloadCount: 342,
  },
  {
    id: 'MAT002',
    name: 'Housing Loan-i Comparison Guide',
    type: 'guide',
    product: 'PROD002',
    fileSize: '5.1 MB',
    thumbnail: '/assets/materials/hl-guide-thumb.png',
    downloadCount: 518,
  },
  {
    id: 'MAT003',
    name: 'Credit Card-i Benefits Poster',
    type: 'poster',
    product: 'PROD003',
    fileSize: '1.8 MB',
    thumbnail: '/assets/materials/cc-poster-thumb.png',
    downloadCount: 189,
  },
  {
    id: 'MAT004',
    name: 'iMoney Referral Program Banner',
    type: 'banner',
    product: null,
    fileSize: '850 KB',
    thumbnail: '/assets/materials/referral-banner-thumb.png',
    downloadCount: 725,
  },
  {
    id: 'MAT005',
    name: 'Auto Financing-i Rate Card',
    type: 'brochure',
    product: 'PROD005',
    fileSize: '1.2 MB',
    thumbnail: '/assets/materials/af-ratecard-thumb.png',
    downloadCount: 267,
  },
  {
    id: 'MAT006',
    name: 'Property Investment Guide 2025',
    type: 'guide',
    product: 'PROD004',
    fileSize: '8.3 MB',
    thumbnail: '/assets/materials/property-guide-thumb.png',
    downloadCount: 412,
  },
  {
    id: 'MAT007',
    name: 'Raya 2025 Campaign Poster',
    type: 'poster',
    product: null,
    fileSize: '2.1 MB',
    thumbnail: '/assets/materials/raya-poster-thumb.png',
    downloadCount: 156,
  },
  {
    id: 'MAT008',
    name: 'Agent Onboarding Kit',
    type: 'guide',
    product: null,
    fileSize: '12.5 MB',
    thumbnail: '/assets/materials/agent-kit-thumb.png',
    downloadCount: 893,
  },
];
